// COP-UX-160: model formatting renders as clean readable text — raw Markdown control
// characters (**, __, leading #, backticks, leading "- " list markers) never leak
// into ordinary answers (V4.6 CMD-14-008: dash bullets render as real bullets).
export const renderText = (s) => (s || "")
  .replace(/\*\*(.+?)\*\*/g, "$1")
  .replace(/__(.+?)__/g, "$1")
  .replace(/^#{1,6}\s+/gm, "")
  .replace(/`{1,3}([^`]+)`{1,3}/g, "$1")
  .replace(/^[-*]\s+/gm, "• ");
